// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-show[data-v-65841011] {\r\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);\r\n  min-width: 500px;\r\n  width: 800px;\n}\n.chat-show.alone[data-v-65841011] {\r\n  width: 620px;\n}\r\n", ""]);
// Exports
module.exports = exports;
